
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  LanguageCommunicationAvailable,
  LanguageCommunicationPreference,
} from '../models';
import {
    LanguageCommunicationAvailableFromJSON,
    LanguageCommunicationAvailableToJSON,
    LanguageCommunicationPreferenceFromJSON,
    LanguageCommunicationPreferenceToJSON,
} from '../models';

export interface UpdateLanguageCommunicationPreferenceRequest {
    languageCommunicationPreference: LanguageCommunicationPreference;
}

/**
 * 
 */
export class AccountCommunicationPreferencesResourceApi extends runtime.BaseAPI {

    /**
          */
    async getAvailableLanguagesCommunicationRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LanguageCommunicationAvailable>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LanguageCommunicationAvailable>({
            path: `/account/api/notifications-preferences/language/available`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LanguageCommunicationAvailableFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getAvailableLanguagesCommunication(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LanguageCommunicationAvailable> {
        const response = await this.getAvailableLanguagesCommunicationRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getLanguageCommunicationPreferenceRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<LanguageCommunicationPreference>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<LanguageCommunicationPreference>({
            path: `/account/api/notifications-preferences/language`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=LanguageCommunicationPreferenceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getLanguageCommunicationPreference(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<LanguageCommunicationPreference> {
        const response = await this.getLanguageCommunicationPreferenceRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async updateLanguageCommunicationPreferenceRaw(requestParameters: UpdateLanguageCommunicationPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['languageCommunicationPreference'] == null) {
            throw new runtime.RequiredError(
                'languageCommunicationPreference',
                'Required parameter "languageCommunicationPreference" was null or undefined when calling updateLanguageCommunicationPreference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/notifications-preferences/language`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LanguageCommunicationPreferenceToJSON(requestParameters['languageCommunicationPreference']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async updateLanguageCommunicationPreference(requestParameters: UpdateLanguageCommunicationPreferenceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateLanguageCommunicationPreferenceRaw(requestParameters, initOverrides);
    }

}
